import { Box, CircularProgress } from "@chakra-ui/react";
import React from "react";

const Loading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress isIndeterminate color="blue.500" />
    </Box>
  );
};

export default Loading;
